module.exports = __webpack_public_path__ + "static/media/luggage-cart.72fb33ea.svg";